/* OsCatalogImagesComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsCatalogImagesRenderer");

class OsCatalogImagesComponent extends EventEmitter {
    constructor(osCatalogDetailsView) {
        super();
        this._osCatalogDetailsView = osCatalogDetailsView;
        this._gameEditor = osCatalogDetailsView.getGameEditor();
        this._osImagePathsEntity = this._gameEditor.osImagesPathsEntity;
        this._osImageEntity = this._gameEditor.osImagesEntity;
        this._osCatalogEntity = this._gameEditor.getOsCatalog();
        this._gridKey = "osCatalog_images";
        this._componentMainLabel = "Images";
        this._pagingImagesFeed = undefined;
        this._activeOrgId = this._gameEditor._activeOrgId;
        this._pathsData = undefined;
        this._selectedImages = [];
        this._currentSelection = [];
        this._imagesFeed = undefined;
        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._osCatalogEntity.on("DirtyStateChanged", (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this)));
    }

    _unregisterListeners() {
        this._osCatalogEntity.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
    }

    shutdown() {
        return this._renderer
            .shutdown()
            .then(() => {
                return this._imagesFeed.shutdown();
            })
            .then(() => {
                this._osCatalogDetailsView = undefined;
                this._gameEditor = undefined;
                this._osImagePathsEntity = undefined;
                this._osImageEntity = undefined;
                this._osCatalogEntity = undefined;
                this._renderer = undefined;
                this._activeOrgId = undefined;
                this._gridKey = undefined;
                this._pathsData = undefined;
                this._selectedImages = undefined;
                this._selectedImagesFeed = undefined;
                this._pagingImagesFeed = undefined;
                this._imagesFeed = undefined;
            })
            .catch((err) => {
                this._logger.warn(err, "OsCatalogImagesComponent.shutdown() error.");
            });
    }

    groupTree(data = []) {
        const rootId = null;
        const map = data.reduce((map, item) => {
            const { id, parentId } = item;
            map[id] = map[id] || { children: [] };

            Object.assign(map[id], item);

            if (parentId === rootId) {
                map[parentId] = map[id];
            } else {
                map[parentId] = map[parentId] || { id: parentId, children: [] };
                map[parentId].children.push(map[id]);
            }
            return map;
        }, {});
        return map[rootId];
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get osCatalogDetailsView() {
        return this._osCatalogDetailsView;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    getOsCatalogEntity() {
        return this._osCatalogEntity;
    }

    get osCatalogEntity() {
        return this.getOsCatalogEntity();
    }

    whenModelIsReady() {
        return this.whenSelectedImagesModelIsReady()
            .then((feed) => {
                this._selectedImagesFeed = feed;
                return this._osImagePathsEntity.retrievePaths(this._activeOrgId);
            })
            .then((pathsEntity) => {
                return pathsEntity.getPaths();
            })
            .then((paths) => {
                this._pathsData = paths;
            });
    }

    whenSelectedImagesModelIsReady() {
        const query = { status: { $nin: ["DRAFT", "PENDING_UPLOAD", "UPLOADING"] } };
        return this._osCatalogEntity.loadRelatedOsImages(query, {}, false, false).then((res) => {
            this._pagingImagesFeed = res;
            return Promise.resolve(this._pagingImagesFeed);
        });
    }

    whenFeedIsReady(feed) {
        return feed.whenFeedReady();
    }
    _reestablishfeed() {
        if (!_.isUndefined(this._imagesFeed)) {
            this._imagesFeed._feedReestablish();
        }
        if (!_.isUndefined(this._pagingImagesFeed)) {
            this._pagingImagesFeed._feedReestablish();
        }
    }
    whenImagesModelIsReady() {
        const query = { status: { $nin: ["DRAFT", "PENDING_UPLOAD", "UPLOADING"] } };
        return this._osImageEntity.loadOsImages(this._activeOrgId, query, {}, {}, false).then((res) => {
            this._imagesFeed = res;
            return Promise.resolve(this._imagesFeed);
        });
    }

    validateImagesDetails() {
        if (this._selectedImages.length === 0) {
            return this._osCatalogDetailsView._modalUserFeedback.displayError({
                error: {
                    errorMsg: `The OS Catalog ${this._osCatalogEntity.getName()} must contain at least one image.`
                }
            });
        } else {
            return Promise.resolve();
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    _onDirtyStateChanged(dirtyState) {
        this.emit("Dirty", dirtyState);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = OsCatalogImagesComponent;
